import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { ReportService } from '@cloudia-shared/apis/generated/reports-api';

@Injectable({ providedIn: 'root' })
export class CanAccessService {
  constructor(
    private readonly kc: KeycloakService,
    private readonly authService: AuthService,
    private readonly reportService: ReportService
  ) {}

  canAccess(accessRoles: string[], accessReports = []): Observable<boolean> {
    return of(this.authService.isUserLoggedIn()).pipe(
      switchMap((userLogged) => {
        if (userLogged) {
          let accessGranted = !accessRoles || accessRoles.length === 0;
          if (accessRoles) {
            for (const role of accessRoles) {
              accessGranted = this.kc.isUserInRole(role.toString());
              if (accessGranted) {
                break;
              }
            }
          }
          if (
            accessGranted &&
            Array.isArray(accessReports) &&
            accessReports?.length > 0
          ) {
            return this.canReportAccess(accessReports);
          } else {
            return of(accessGranted);
          }
        }
      })
    );
  }

  canReportAccess(reports: string[]): Observable<boolean> {
    return of(this.authService.isUserLoggedIn()).pipe(
      switchMap((userLogged) => {
        if (userLogged) {
          let accessGranted = !reports || reports.length === 0;
          if (reports) {
            return this.reportService
              .getReports('{}', { page: 0, size: 1000 })
              .pipe(
                switchMap((allowedReports) => {
                  accessGranted =
                    allowedReports?.content.filter((item) =>
                      reports.includes(item?.slug)
                    ).length > 0;
                  return of(accessGranted);
                })
              );
          } else {
            return of(accessGranted);
          }
        }
      })
    );
  }
}
